import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import type { Movie } from '@/mocks/movies';

interface MovieGridProps {
  title: string;
  movies: Movie[];
  viewAllLink?: string;
}

export default function MovieGrid({ title, movies, viewAllLink }: MovieGridProps) {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            {title}
          </h2>
          {viewAllLink && (
            <Link
              to={viewAllLink}
              className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap font-medium"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          )}
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 md:gap-4">
          {movies.map((movie, index) => (
            <div key={movie.id} className="animate-fade-in-up" style={{ animationDelay: `${index * 0.06}s` }}>
              <MovieCard movie={movie} index={index} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}